(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("455Yx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f8c43a8847a3762$export$2e2bcd8739ae039; });

var $2Xzd1 = parcelRequire("2Xzd1");
var $2f8c43a8847a3762$var$heroVideo = {
    MOBILE_BP: 782,
    init: function(root) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _blocks;
        var scope = root || document;
        var blocks = [];
        if (scope.matches && scope.matches('.hero-home')) blocks.push(scope);
        if (scope.querySelectorAll) (_blocks = blocks).push.apply(_blocks, (0, $2Xzd1._)(scope.querySelectorAll('.hero-home')));
        blocks.forEach(function(block) {
            return _this.bindBlock(block, options);
        });
    },
    bindBlock: function(block) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (block.dataset.heroReady === 'true') return;
        block.dataset.heroReady = 'true';
        if (block.matches('.hero-home--video')) {
            this.loadCurrentVideo(block, options);
            // The canvas resizes constantly as panels open; the frontend does not.
            if (!options.isEditor) window.addEventListener('resize', function() {
                return _this.loadCurrentVideo(block, options);
            });
        }
        this.initYoutubeFacades(block, options);
    },
    loadCurrentVideo: function(block) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var isMobile = block.ownerDocument.defaultView.innerWidth < this.MOBILE_BP;
        var desktopVideo = block.querySelector('.hero-home__video--desktop');
        var mobileVideo = block.querySelector('.hero-home__video--mobile');
        var video = isMobile ? mobileVideo : desktopVideo;
        if (!video || video.src || !video.dataset.src) return;
        video.src = video.dataset.src;
        video.load();
        // Otherwise the editor plays video while you type.
        if (!options.isEditor) video.play();
    },
    initYoutubeFacades: function(block) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        block.querySelectorAll('.hero-home__yt-facade').forEach(function(facade) {
            facade.addEventListener('click', function() {
                // Keeps a third-party player out of the editor.
                if (options.isEditor) return;
                // Released by the Axeptio script in the footer once the visitor consents.
                if (facade.getAttribute('data-consent-required') === 'youtube') {
                    if (window.openAxeptioCookies) window.openAxeptioCookies();
                    return;
                }
                var id = facade.dataset.ytId;
                if (!id) return;
                var iframe = facade.ownerDocument.createElement('iframe');
                iframe.src = "https://www.youtube-nocookie.com/embed/".concat(id, "?autoplay=1&rel=0");
                iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
                iframe.allowFullscreen = true;
                iframe.title = 'YouTube video player';
                facade.innerHTML = '';
                facade.appendChild(iframe);
            });
        });
    }
};
var $2f8c43a8847a3762$export$2e2bcd8739ae039 = $2f8c43a8847a3762$var$heroVideo;
if (!window.acf) window.addEventListener('DOMContentLoaded', function() {
    return $2f8c43a8847a3762$var$heroVideo.init(document, {
        isEditor: false
    });
});

});
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});




parcelRequire("455Yx");
})();
//# sourceMappingURL=script.js.map
